<!-- 社区生活服务饼图 -->
<template>
    <div class="nodataBox" v-if="nodata">暂无数据</div>
    <div class='' :id="'echart1'+index" style="width:100%;height:100%" v-else></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
 // 引入 ECharts 主模块
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    inject:['isSmallWidth'],
    components: {},
  props:{
    index:{
      type:null,
      default:0,
    },
    token:{
      type:String,
      default: ''
    }
  },
    data() {
    //这里存放数据
        return {
            origindata:[],
            nodata:false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        initEcharts (ecdata) {
            //各社区八大类对比情况
          var id = 'echart1'+this.index
            var echart1 = echarts.init(document.getElementById(id));
            // var isJiedao = sessionStorage.isJiedao
            //var data1 = that.echarts1
            let option1= {
                //color:['#ff9a4c','#7192f1','#52d285','#ff6411','#ffdd3e'],
                color:ecdata.color,
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    left:this.isSmallWidth?2:20,
                    top:'middle',
                    data:ecdata.legend2,
                    itemHeight:10,
                    itemWidth:this.isSmallWidth?6:10,
                    textStyle:{    //图例文字的样式
                        color:'#91b1fc',  //文字颜色
                        fontSize:12
                    },
                },
                series: [
                    {
                        name:'企业类型',
                        type:'pie',
                        radius: ['50%', '70%'],
                        center: [this.isSmallWidth?"80%":"70%", "50%"],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:ecdata.series
                    }
                ]
            };

            echart1.setOption(option1)
            echart1.on('click', (params)=>{
                this.getQyList(params.dataIndex)
                console.log(params.dataIndex);
            });
        },
      initCongtaiEcharts (ecdata) {
        //各社区八大类对比情况
        var id = 'echart1'+this.index
        var echart1 = echarts.init(document.getElementById(id));
        // var isJiedao = sessionStorage.isJiedao
        //var data1 = that.echarts1
        let option1= {
          color:ecdata.color,
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            x: 'left',
            left:this.isSmallWidth?2:20,
            top:'middle',
            icon:'path://M67.9,42.9c-9.3-9.3-24.2-9.3-33.5,0l16.7,16.7L67.9,42.9z',
            itemHeight:10,
            itemWidth:this.isSmallWidth?6:10,
            formatter: function (name) {
              var dataList =  ecdata.series,
                value=0,
                total = 0
              dataList.forEach(item => {
                total = total+item.value*1
                if (item.name == name) {
                  value = item.value
                }
              })
              return '{a|'+name+'}'+'{b|'+value+'家}'+ '{b|'+((value/total)*100).toFixed(2)+'%}'
            },
            textStyle:{
              rich: {
                a: {
                  color:'#91b1fc',  //文字颜色
                  fontSize:16,
                  width:80,
                },
                b: {
                  color:'#9a9c9b',
                  fontSize:16,
                  width:45,
                },
                c:{
                  color:'#9a9c9b',
                  fontSize:11,
                  width:20
                }
              }
            }
          },
          series: [
            {
              name:'企业类型',
              type:'pie',
              radius: ['45%', '80%'],
              center: ["75%", "50%"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data:ecdata.series
            }
          ]
        };
        echart1.setOption(option1)
        echart1.on('click', (params)=>{
          this.getQyList(params.dataIndex)
          console.log(params.dataIndex);
        });
      },
        getFuwuEc() {
           // var url = this.urlobj.getShouyeEc('service')
           var url = this.urlobj.getCompany('service')
            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                    let nodatalist = res.rows[0].series.filter(item => item.data[0]>0)
                    if(nodatalist.length == 0){
                        this.nodata = true;
                        return
                    }
                    this.origindata = res.rows[0]
                    let ec2 = res.rows[0]
                    ec2.color = ec2.series.map(item => {
                        return item.color
                    })
                    ec2.series = ec2.series.map(item => {
                        return {
                        id:item.id,
                        name:item.name,
                        value:item.data[0]
                        }
                    })
                    ec2.legend2 = ec2.legend.map(item=>{
                        return {
                            name:item,
                            icon : 'path://M67.9,42.9c-9.3-9.3-24.2-9.3-33.5,0l16.7,16.7L67.9,42.9z',
                            textStyle: {
                              color: '#91b1fc'          // 图例文字颜色
                            }
                        }
                    })
                  if (!this.token) {
                    this.initEcharts(ec2)
                  }else {
                    this.initCongtaiEcharts(ec2)
                  }

                } else {

                }
            }).catch(e => {
            })

        },
        getQyList(index) {
            let serviceIdList = []
            console.log(this.origindata)
            console.log(index)
            serviceIdList.push(this.origindata.series[index].id)
            //获取某一分类下的企业列表
            let url = this.urlobj.getQyList;
            this.$post(url, {
                pageSize:0,
                pageNum:0,
                serviceIdList:serviceIdList
            })
            .then(res => {
                if (res.rows.length) {
                    /* 初始化数据 */
                   let returndata = {
                       color:this.origindata.color[index],
                       list:res.rows.filter(item => item.coordinate).map(item=>{
                           return {
                              id:item.id,
                              name:item.companyName,
                              position:item.coordinate,
                              opacity:(Math.random()+0.3).toFixed(1),
                           }
                       })
                   }
                   console.log(returndata)
                   this.$emit('setMarkers',returndata)
                } else {
                }
            })
            .catch(e => {
                console.log(e);
            });
            // this.page += 1; // 分页加1
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getFuwuEc()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
    height: 100%;
}
</style>
